// src/utils/useTheme.js
import { useTheme as useThemeContext } from '../context/ThemeContext';

export default function useTheme() {
  return useThemeContext();
}